module.exports = __webpack_public_path__ + "img/BA.ff62357b.svg";